import { Link } from 'react-router-dom';

import Input from 'components/input/input';

import { referralShape } from 'helpers/shared_types';
import { ReactComponent as ArrowRightSVG } from 'icons/arrow-right.svg';
import { ReactComponent as StethoscopeSVG } from 'icons/stethoscope.svg';
import { ReactComponent as UserSVG } from 'icons/user.svg';

import {
  REFERRAL_ACTION_OPTIONS,
  DOCTOR_TYPES,
  NEXT_CONSULTATION_OPTIONS,
} from 'config/referral';

import { formatDatetime } from 'helpers/timezone';
import Textarea from 'components/textarea/textarea';

const ViewComponent = ({ referral }) => {
  const customerName = [
    referral.customer.lastName?.toUpperCase(),
    referral.customer.firstName,
  ]
    .filter(Boolean)
    .join(' ');

  const doctorName = [
    referral.doctor.lastName?.toUpperCase(),
    referral.doctor.firstName,
  ]
    .filter(Boolean)
    .join(' ');

  const title =
    REFERRAL_ACTION_OPTIONS.find((n) => n.id === referral.referralActionType)
      ?.cardTitle || 'nurse teleconsultation';

  const referPatientFor =
    REFERRAL_ACTION_OPTIONS.find((a) => a.id === referral.referralActionType)
      ?.title || 'Nurse teleconsultation';

  return (
    <main className="th-main">
      <section className="th-canvas">
        <header className="th-canvas-header">
          <h2 className="th-canvas-title">
            <Link to={`/customers/${referral.customer.id}`}>
              {customerName}
            </Link>
            <span>
              <ArrowRightSVG />
            </span>
            Referral for {title}
          </h2>
        </header>

        <div className="pa5 pt4 br4 shadow-1 bg-grouped-table flex flex-column justify-between">
          <h3 className="flex align-center f2 fw6 ma0 pa0">
            Referral for {title}
          </h3>
          <div className="mt6 flex margin-between middarkgrey">
            <div className="flex items-center f7 pt1 ma0 nudge-bottom--2">
              <StethoscopeSVG className="h6 w6 mr2" />
              {doctorName}
            </div>

            <div className="flex items-center f7 pt1 ma0 nudge-bottom--2">
              <UserSVG className="h6 w6 mr2" />
              <Link
                className="middarkgrey underline"
                to={`/customers/${referral.customer.id}`}
              >
                {customerName}
              </Link>
            </div>
          </div>
        </div>

        <div className="mt10 pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column justify-between">
          <div className="w-100 flex flex-column items-start justify-between margin-between">
            <div className="w-100 flex justify-between margin-between">
              <div className="w-50">
                <Input
                  name="createdAt"
                  valid={true}
                  label="Creation date"
                  value={formatDatetime(referral.createdAt)}
                  disabled
                />
              </div>
              <div className="w-50">
                <Input
                  name="actionType"
                  valid={true}
                  label="Refer patient for"
                  value={referPatientFor}
                  disabled
                />
              </div>
            </div>
            <div className="w-100 flex flex-row justify-between margin-between">
              <div className="w-100 flex justify-between margin-between">
                <div className="w-50">
                  <Input
                    name="doctor"
                    valid={true}
                    label="Doctor"
                    value={doctorName}
                    disabled
                  />
                </div>
                <div className="w-50">
                  <Input
                    name="doctorType"
                    label="Doctor type"
                    value={
                      DOCTOR_TYPES.find((d) => d.id === referral.doctor.type)
                        ?.title
                    }
                    valid={true}
                    disabled
                  />
                </div>
              </div>
            </div>
            {referral.nextConsultation && (
              <div className="w-100 flex flex-row justify-between margin-between">
                <div className="w-100 flex justify-between margin-between">
                  <div className="w-50">
                    <Input
                      name="nextConsultation"
                      valid={true}
                      label="Next consultation with patient"
                      value={
                        NEXT_CONSULTATION_OPTIONS.find(
                          (o) => o.id === referral.nextConsultation,
                        )?.title
                      }
                      disabled
                    />
                  </div>
                  <div className="w-50"></div>
                </div>
              </div>
            )}
            {referral.reason && (
              <div className="w-100 flex-row items-start justify-between margin-between">
                <div className="w-100 flex flex-row justify-between margin-between">
                  <div className="w-100">
                    <Textarea
                      name="reason"
                      label="Reason for referral"
                      value={referral.reason}
                      valid={true}
                      disabled
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </main>
  );
};

ViewComponent.propTypes = {
  referral: referralShape,
};

export default ViewComponent;
